import { useStore } from "../stores"
import userAxios from "./axios"
import { preloadImages } from "./helpers"

async function loadRewards(){
	const store = useStore()
	const imagesToPreload = []

	const items = (await userAxios.get('/api/user-side/getUserActiveRewards')).data || []

	for(const item of items) {
		item.imageUrl = `/image/i.${item.image_id}/w.100:h.100:f.0/image.png`
		imagesToPreload.push(item.imageUrl);
	}

	await preloadImages(imagesToPreload)

	store.rewards = items
}

export {
	loadRewards
}